"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopAllSounds = exports.stop = exports.playWithRandomRate = exports.playWithChannel = exports.playRandom = exports.play = exports.playOn = exports.isSoundMuted = exports.playMusic = exports.playAmbientUnmanaged = exports.stopAmbientUnmanaged = exports.playAmbient = exports.load = exports.getAmbientSprite = exports.getMusicSprite = exports.getSoundSprite = exports.setAmbientVolume = exports.setMusicVolume = exports.setSoundVolume = void 0;
var howler = __importStar(require("howler"));
var log_sidecar_1 = require("./log-sidecar");
var pubSub_sidecar_1 = require("./pubSub-sidecar");
// import { settings } from '../main/se'
var imports_1 = require("../lib/imports");
var settings_sidecar_1 = require("./settings-sidecar");
var rando_sidecar_1 = require("../lib/rando-sidecar");
// export interface ISoundSprite {
//   once: (event: 'load', cb: () => void) => void
// //   on: (event: 'loaderror' | 'end', cb: (id: string, err: any) => void) => void
// //   stop: (soundKey?: string) => void
// //   play: (soundKey?: string) => void
// //   mute: (mute: boolean) => void
// // }
var soundSprite = null;
var musicSprite = null;
var ambientSprite = null;
var verbose = false;
var logNamespace = 'soundGeneric';
var _soundVolume = 5;
function setSoundVolume(vol) {
    settings_sidecar_1.settings.update({ soundVolume: vol });
    _soundVolume = vol;
}
exports.setSoundVolume = setSoundVolume;
var _musicVolume = 5;
var _lastMusicVolume = 1;
function setMusicVolume(vol) {
    settings_sidecar_1.settings.update({ musicVolume: vol });
    _musicVolume = vol;
    var ms = getMusicSprite();
    if (ms && ms.playing) {
        ms.volume((_lastMusicVolume * _musicVolume) / 10);
    }
}
exports.setMusicVolume = setMusicVolume;
var _ambientVolume = 5;
function setAmbientVolume(vol) {
    settings_sidecar_1.settings.update({ ambientVolume: vol });
    _ambientVolume = vol;
}
exports.setAmbientVolume = setAmbientVolume;
function getSoundSprite() {
    return soundSprite;
}
exports.getSoundSprite = getSoundSprite;
function getMusicSprite() {
    return musicSprite;
}
exports.getMusicSprite = getMusicSprite;
function getAmbientSprite() {
    return ambientSprite;
}
exports.getAmbientSprite = getAmbientSprite;
function load(jsonAudioSprite, callbackOnLoaded) {
    _soundVolume = settings_sidecar_1.settings.get().soundVolume;
    _musicVolume = settings_sidecar_1.settings.get().musicVolume;
    _ambientVolume = settings_sidecar_1.settings.get().ambientVolume;
    soundSprite = new howler.Howl({
        src: jsonAudioSprite.urls,
        sprite: jsonAudioSprite.sprite,
    });
    if (soundSprite) {
        soundSprite.once('load', function () {
            if (callbackOnLoaded) {
                callbackOnLoaded();
            }
        });
        soundSprite.on('loaderror', function (id, err) {
            log_sidecar_1.log.x(logNamespace, 'error loading sound', id, err);
        });
    }
}
exports.load = load;
function playAmbient(song, loop, cb) {
    if (loop === void 0) { loop = true; }
    if (cb === void 0) { cb = null; }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play ambient', song);
    }
    if (ambientSprite) {
        ambientSprite.stop();
        ambientSprite = null;
    }
    ambientSprite = new howler.Howl({
        src: [song + '.ogg', song + 'mp3'],
        autoplay: true,
        loop: loop,
        volume: (1 * _ambientVolume) / 10,
        mute: settings_sidecar_1.settings.get().muteMusic || _ambientVolume === 0,
    });
    if (ambientSprite) {
        ambientSprite.on('loaderror', function (id, err) {
            log_sidecar_1.log.x(logNamespace, 'error loading ambient', song, id, err);
        });
        if (cb) {
            ambientSprite.on('end', function () {
                cb();
            });
        }
    }
    return ambientSprite;
}
exports.playAmbient = playAmbient;
function stopAmbientUnmanaged(ambientSprite) {
    if (ambientSprite) {
        ambientSprite.stop();
        ambientSprite.unload();
        ambientSprite = null;
    }
}
exports.stopAmbientUnmanaged = stopAmbientUnmanaged;
function playAmbientUnmanaged(song, volume, loop, cb) {
    if (loop === void 0) { loop = false; }
    if (cb === void 0) { cb = null; }
    if (verbose) {
        console.log('playing ambient', song);
    }
    var ambientSprite = new howler.Howl({
        src: [song + '.ogg', song + 'mp3'],
        autoplay: true,
        loop: loop,
        volume: volume,
        mute: settings_sidecar_1.settings.get().muteSound,
    });
    if (ambientSprite) {
        ambientSprite.on('loaderror', function (id, err) {
            log_sidecar_1.log.x(logNamespace, 'error loading ambient', song, id, err);
        });
        if (cb) {
            ambientSprite.on('end', function () {
                log_sidecar_1.log.x(logNamespace, 'ambient finished', song);
                cb();
            });
        }
    }
    return ambientSprite;
}
exports.playAmbientUnmanaged = playAmbientUnmanaged;
function playMusic(song, loop, cb, volume) {
    if (loop === void 0) { loop = true; }
    if (cb === void 0) { cb = null; }
    if (volume === void 0) { volume = 1; }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play music', song);
    }
    _lastMusicVolume = volume;
    if (musicSprite) {
        musicSprite.stop();
        musicSprite = null;
    }
    musicSprite = new howler.Howl({
        src: [song + '.ogg', song + 'mp3'],
        autoplay: true,
        loop: loop,
        volume: (volume * _musicVolume) / 10,
        mute: settings_sidecar_1.settings.get().muteMusic || _musicVolume === 0,
        onend: function () {
            log_sidecar_1.log.x(logNamespace, 'music ended', song);
            if (cb) {
                cb();
            }
        },
    });
    if (musicSprite) {
        //musicSprite.once('load', () => {
        //musicSprite.play()
        //})
        musicSprite.on('loaderror', function (id, err) {
            // console.log('howl', 'loaderror', id, err)
            log_sidecar_1.log.x(logNamespace, 'error loading music', song, id, err);
        });
    }
}
exports.playMusic = playMusic;
function isSoundMuted() {
    return settings_sidecar_1.settings.get().muteSound || _soundVolume === 0;
}
exports.isSoundMuted = isSoundMuted;
function playOn(_soundSprite, soundKey) {
    if (isSoundMuted()) {
        return -1;
    }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play', soundKey);
    }
    return _soundSprite.play(soundKey);
}
exports.playOn = playOn;
function play(soundKey, volume) {
    if (volume === void 0) { volume = 1; }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play sound', soundKey);
    }
    if (isSoundMuted() || !soundSprite) {
        return -1;
    }
    var id = soundSprite.play(soundKey);
    soundSprite.volume((volume * _soundVolume) / 10, id);
    // soundSprite.rate(1, id)
}
exports.play = play;
function playRandom(soundKeys, volume) {
    if (volume === void 0) { volume = 1; }
    var sk = rando_sidecar_1.rando.sample(soundKeys);
    play(sk, volume);
}
exports.playRandom = playRandom;
function playWithChannel(soundKey, channel, volume) {
    if (isSoundMuted() || !soundSprite) {
        return -1;
    }
    var id = soundSprite.play(soundKey);
    soundSprite.stereo(channel, id);
    soundSprite.volume((volume * _soundVolume) / 10, id);
}
exports.playWithChannel = playWithChannel;
function playWithRandomRate(soundKey, baseRate, variance, volume) {
    if (baseRate === void 0) { baseRate = 1; }
    if (variance === void 0) { variance = 0.125; }
    if (volume === void 0) { volume = 1; }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play sound w rate', soundKey);
    }
    if (isSoundMuted() || !soundSprite) {
        return -1;
    }
    if (verbose) {
        log_sidecar_1.log.x(logNamespace, 'play', soundKey);
    }
    var id = soundSprite.play(soundKey);
    var rate = baseRate + imports_1.l.random(-variance, variance, true);
    soundSprite.rate(rate, id);
    soundSprite.volume((volume * _soundVolume) / 10, id);
}
exports.playWithRandomRate = playWithRandomRate;
function stop(id) {
    if (soundSprite) {
        soundSprite.stop(id);
    }
}
exports.stop = stop;
function stopAllSounds() {
    if (soundSprite) {
        soundSprite.stop();
    }
}
exports.stopAllSounds = stopAllSounds;
function updateMusicMute() {
    if (!musicSprite) {
        return;
    }
    musicSprite.mute(settings_sidecar_1.settings.get().muteMusic);
}
pubSub_sidecar_1.pubSub.on('settings:update', function () {
    updateMusicMute();
    if (settings_sidecar_1.settings.get().muteSound) {
        stopAllSounds();
    }
});
